<!-- QuickPlan 共用 側邊欄 -->
<template>
  <el-aside :class="classValue">
    <Terms :visible.sync="dialogVisible"></Terms>
    <router-link class="sidebar-button"
      :to="menu.link"
      v-for="(menu, index) in menus" :key="index"
      :class="[{ active: menu.link === $route.matched[1].path }, {hide: !menu.use}]">
      <template v-if="menu.use">
        <i :class="['sidebar-icon', menu.icon]"></i>
        {{ menu.name }}
      </template>
    </router-link>
    <div class="info">
      <span>OneAD ⓒ {{ dateFormat(new Date, 'YYYY') }}. All Rights Reserved</span>
      <span style="margin-top: 8px; cursor: pointer;" @click='openTerms'>使用者政策/隱私權條款</span>
    </div>
  </el-aside>
</template>

<script>
import dateFormat from 'date-fns/format'
import { ROUTE_PATH } from '../router/Const'
import Terms from '@/views/terms.vue'

export default {
  components: { Terms },
  name: 'AppSidebar',
  data () {
    return {
      dateFormat,
      dialogVisible: false
    }
  },
  computed: {
    currentPath () {
      return this.$route.path
    },
    classValue () {
      return 'sidebar' + (this.$store.state.appSidebar.show ? '' : ' hide')
    },
    /**
     * name: 顯示於menu的名稱
     * link: vue-router中定義的path
     * icon: font awesome class name
     * use: 是否顯示
     */
    menus () {
      return [
        {
          name: '導引流程',
          link: ROUTE_PATH.GUIDE.ROOT,
          icon: 'fas fa-rocket',
          use: true
        },
        {
          name: '計算頁面',
          link: '/calculation/SuperImpact',
          icon: 'fas fa-vial',
          use: true
        },
        {
          name: '計算總覽',
          link: '/compare',
          icon: 'fas fa-vials',
          use: true
        }
      ]
    }
  },
  methods: {
    openTerms () {
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/z-index.scss';
.sidebar {
  position: fixed;
  z-index: map-get($z-index, AppSidebar);
  height: calc(100vh - 48px );
  margin-top: 48px;
  display: flex;
  flex-direction: column;
  // height: 100vh;
  width: 240px !important;
  background-image: linear-gradient(347deg, #b2d4f0, #2d89d6);
  box-shadow: 0 4px 6px 0 #dfdfdf;
  &-button {
    padding: 16px;
    color: #ffffff;
    text-align: left;
    text-decoration: none;
    letter-spacing: -1px;
    font-weight: normal;
    font-size: 18px;
    cursor: pointer;
    &:hover,
    &.active {
      background-color: rgba(53, 131, 190, 0.6);
    }
  }
  &-icon {
    margin: 0 5px 0 0;
    width: 20px !important;
    color: rgba(255, 255, 255, 0.5);
  }
  .info {
    position: absolute;
    padding-left: 20px;
    width: 100%;
    bottom: 15px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    color: #3583be;
    font-size: 12px;
    flex-direction: column;
  }
  .hide{
    display: none
  }
}
</style>
